

window.prepareNavigationScroll = function (navigation) {

    const parentBlock = navigation.parentElement
    var heightElements = navigation.offsetHeight
    var heightBlock = parentBlock.offsetHeight
    
    if (heightElements > heightBlock) {

        var scrollSumary = 66

        var nextBtn = document.createElement('button')
        nextBtn.classList.add('product-gallery__next-prev', 'product-gallery__next-prev--next')
        nextBtn.innerHTML = '<i class="fa fa-chevron-down"></i>'
        parentBlock.appendChild(nextBtn)

        var prevBtn = document.createElement('button')
        prevBtn.classList.add('product-gallery__next-prev', 'product-gallery__next-prev--prev')
        prevBtn.innerHTML = '<i class="fa fa-chevron-up"></i>'
        prevBtn.classList.add('hidden')
        parentBlock.appendChild(prevBtn)

        nextBtn.addEventListener('click', () => {
            navigation.style.top = `-${scrollSumary}px`

            if (scrollSumary > 0 && prevBtn && prevBtn.classList.contains('hidden')) {
                prevBtn.classList.remove('hidden')
            }
            
            if (scrollSumary > heightElements-heightBlock+47) {
                nextBtn.classList.add('hidden')
            }
            else {
                scrollSumary += 66
            }
            
        })

        prevBtn.addEventListener('click', () => {

            scrollSumary -= 66

            navigation.style.top = `-${scrollSumary}px`

            if (scrollSumary < 10 && prevBtn && !prevBtn.classList.contains('hidden')) {
                prevBtn.classList.add('hidden')
            }

            if (scrollSumary < heightElements-heightBlock+47) {
                nextBtn.classList.remove('hidden')
            }
            
        })

        
    }
}

window.parseGalleryItem = function (gallery) {

    const navigation = gallery.querySelector('.gallery-navigation')
    const activePhoto = gallery.querySelector('.gallery-active-photo img')

    prepareNavigationScroll(navigation)

    const navigationItems = navigation.querySelectorAll('.gallery-navigation__item')

    navigationItems.forEach(navItem => {
        navItem.addEventListener('click', (event) => {
            var imgSrc = event.target.getAttribute("data-src")
            if (imgSrc) {
                activePhoto.src = imgSrc

                navigationItems.forEach(element => {
                    if (element.classList.contains('gallery-navigation__item--active')) {
                        element.classList.remove('gallery-navigation__item--active')
                    }
                })

                navItem.classList.add('gallery-navigation__item--active')
            }

        })
    })

}

window.galleryNavigations = function () {
    const galleries = document.querySelectorAll('[data-toggle="navigation-gallery"]')

    galleries.forEach(gallery => {
        parseGalleryItem(gallery)
    })
}